// Smooth navigation utility to prevent content flashing while maintaining good UX
export const smoothNavigate = (url, options = {}) => {
  const { 
    fadeOutDuration = 200, 
    delay = 50,
    clearStorage = false,
    clearSelectedArtist = false 
  } = options;

  return new Promise((resolve) => {
    // Get the app container
    const appElement = document.querySelector('#root');
    
    if (appElement) {
      // Start fade out animation
      appElement.style.opacity = '0';
      appElement.style.transition = `opacity ${fadeOutDuration}ms ease-out`;
    }

    // Clear storage if requested
    if (clearStorage) {
      localStorage.removeItem("dizeeUser");
      localStorage.removeItem("dizeeToken");
      localStorage.removeItem("persist:root");
      localStorage.removeItem("selectedArtist");
      localStorage.clear();
    } else if (clearSelectedArtist) {
      localStorage.removeItem("selectedArtist");
    }

    // Navigate after a short delay
    setTimeout(() => {
      window.location.href = url;
      resolve();
    }, delay);
  });
};

// Smooth page load restoration
export const restorePageOpacity = () => {
  const appElement = document.querySelector('#root');
  if (appElement) {
    appElement.style.opacity = '1';
    appElement.style.transition = 'opacity 300ms ease-in';
  }
};

// Preload important assets for smoother loading
export const preloadAssets = () => {
  // Preload critical CSS if needed
  const criticalStyles = document.createElement('link');
  criticalStyles.rel = 'preload';
  criticalStyles.as = 'style';
  criticalStyles.href = '/static/css/main.css';
  document.head.appendChild(criticalStyles);
}; 